import React from 'react';

import { Divider, Flex, Skeleton } from 'antd-v5';
import { FormattedMessage } from 'react-intl';
import { Heading, Text } from 'scouting-ui/lib/Text';

import { useGetOrganizationProfileQuery } from '@modules/rtk/esb-api';
import { UnitGenderPill } from '@shared/components';
import ProgramLogo from '@shared/components/ProgramLogo/ProgramLogo';

import styles from './UnitInformationCard.module.scss';

interface UnitInformationCardProps {
  organizationGuid?: string;
}

export default function UnitInformationCard({
  organizationGuid,
}: UnitInformationCardProps) {
  const { data, isFetching } = useGetOrganizationProfileQuery(
    { orgGuid: organizationGuid! },
    { skip: !organizationGuid },
  );

  const {
    typeId,
    organizationFullName,
    acceptGender,
    councilName,
    districtName,
    charter,
  } = data || {};
  const communityOrganizationName = charter?.communityOrganizationName ?? '';

  return (
    <div className={styles.card}>
      <Heading level={3} font="display-h5">
        <FormattedMessage id="rosterLite.unitInformation.heading" />
      </Heading>
      <Divider className={styles.divider} />
      {isFetching ? (
        <Skeleton active paragraph={{ rows: 3 }} />
      ) : (
        <Flex vertical gap={'small'}>
          <Flex align="center" gap="small">
            <ProgramLogo programId={typeId} />
            <Text font="body-body-2" strong color="color-primary">
              {organizationFullName}
            </Text>
            <UnitGenderPill gender={acceptGender} colored splitFamilyLabel />
          </Flex>
          <Flex vertical gap={0}>
            <Text>
              <strong>
                <FormattedMessage id="rosterLite.unitInformation.council" />:
              </strong>{' '}
              {councilName}
            </Text>
            <Text>
              <strong>
                <FormattedMessage id="rosterLite.unitInformation.district" />:
              </strong>{' '}
              {districtName}
            </Text>
            <Text>
              <strong>
                <FormattedMessage id="rosterLite.unitInformation.charteredOrg" />
                :
              </strong>{' '}
              {communityOrganizationName}
            </Text>
          </Flex>
        </Flex>
      )}
    </div>
  );
}
